/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import {
  checkForNumberOfBets,
  checkForStopOnLoss,
  checkForStopOnWin,
  checkForMaxBet
} from './checkers'

import { increaseBet } from './helper'

class AutoRollLogic {
  constructor(
    _bet,
    _maxBet,
    _onLossIncrease,
    _onLossPercent,
    _onWinIncrease,
    _onWinPercent,
    _stopOnLoss,
    _stopOnWin,
    _numberOfBets,
    _toFix
  ) {
    this.ROLL_OK = 0
    this.ROLL_STOP_ON_LOSS = 1
    this.ROLL_STOP_ON_WIN = 2
    this.ROLL_STOP_ON_NUMBETS = 3
    this.ROLL_STOP_ON_MAX_BET = 4
    this.bet = +_bet
    this.base_bet = _bet
    this.maxBet = _maxBet
    this.onLossIncrease = _onLossIncrease
    this.onLossPercent = _onLossPercent
    this.onWinIncrease = _onWinIncrease
    this.onWinPercent = _onWinPercent
    this.stopOnLoss = _stopOnLoss
    this.stopOnWin = _stopOnWin
    this.numberOfBets = _numberOfBets
    this.toFix = _toFix
    this.currentBets = 0
    this.ggr = 0
    console.log(
      'this.onWinIncrease',
      this.onWinIncrease,
      'this.onLossIncrease',
      this.onLossIncrease
    )
  }

  nextStep(_win) {
    // region  STOP ON NUMBER OF BETS

    this.currentBets++

    if (checkForNumberOfBets(this.currentBets, this.numberOfBets))
      return this.ROLL_STOP_ON_NUMBETS

    // endregion

    this.ggr += +_win
    // console.log('ggr', this.ggr, 'win', _win)

    // region  STOP ON LOSS

    if (checkForStopOnLoss(this.stopOnLoss, this.ggr))
      return this.ROLL_STOP_ON_LOSS

    // endregion

    // region  STOP ON WIN

    if (checkForStopOnWin(this.stopOnWin, this.ggr))
      return this.ROLL_STOP_ON_WIN

    // endregion

    // region  INCREASE OR RESET BET
    this.bet = increaseBet(
      _win,
      this.bet,
      this.base_bet,
      this.onLossIncrease,
      this.onLossPercent,
      this.onWinIncrease,
      this.onWinPercent,
      this.toFix
    )

    // endregion

    // region STOP ON MAX BET
    // console.log('this.bet, this.maxBet', this.bet, this.maxBet)

    if (checkForMaxBet(this.bet, this.maxBet)) return this.ROLL_STOP_ON_MAX_BET

    // endregion

    return this.ROLL_OK
  }
}
export default AutoRollLogic

//   bet = 0
//   base_bet = 0
//   maxBet = 0
//   onLossReset = 0
//   onLossPercent = 0
//   onWinReset = 0
//   onWinPercent = 0
//   stopOnLoss = 0
//   stopOnWin = 0
//   numberOfBets = 0
//   currentBets = 0
//   toFix = 0
//   data = {}

//   setSettings(
//     _bet,
//     _maxBet,
//     _onLossReset,
//     _onLossPercent,
//     _onWinReset,
//     _onWinPercent,
//     _stopOnLoss,
//     _stopOnWin,
//     _numberOfBets,
//     _toFix
//   ) {
//     console.log(
//       '_bet=' +
//         _bet +
//         '_maxBet=' +
//         _maxBet +
//         ', _onLossReset=' +
//         _onLossReset +
//         ', _onLossPercent=' +
//         _onLossPercent +
//         ', _onWinReset=' +
//         _onWinReset +
//         ', _onWinPercent=' +
//         _onWinPercent +
//         ', _stopOnLoss=' +
//         _stopOnLoss +
//         ', _stopOnWin=' +
//         _stopOnWin,
//       ', _toFix=' + _toFix
//     )
//     // this.numBets = 0
//     this.bet = +_bet
//     this.base_bet = _bet
//     this.maxBet = _maxBet
//     this.onLossReset = _onLossReset
//     this.onLossPercent = _onLossPercent
//     this.onWinReset = _onWinReset
//     this.onWinPercent = _onWinPercent
//     this.stopOnLoss = _stopOnLoss
//     this.stopOnWin = _stopOnWin
//     this.numberOfBets = _numberOfBets
//     this.toFix = _toFix
//     this.ggr = 0
//     if (this.onWinReset === '1') this.onWinPercent = 0
//     if (this.onLossReset === '1') this.onLossPercent = 0
//   }
